<template>

</template>
<script>
import CONST from "@/utils/Constants";
import GAMixins from "@global/lptGoogleAnalytics/mixins/GAMixins";

export default {
  name: "NewsletterComponent",
  data() {

  },
  mixins:[GAMixins],
  created() {
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.NEWSLETTER, () => {
      ACC.log.group("NEWSLETTER")

      const entry = {
        event: 'nl_subscription',
      }
      this.pushEvent(entry);

      console.groupEnd();
    });
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/NewsletterComponent.vue